import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { formatApiError } from '../lib/api';
import { Eye, EyeSlash } from '@phosphor-icons/react';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === 'ADMIN' ? '/admin/dashboard' : '/espace-membre/dashboard');
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="pt-20 min-h-screen flex items-center justify-center" data-testid="login-page">
      <div className="w-full max-w-md px-6">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-desti-gold mb-3">Espace client</p>
          <h1 className="font-heading text-3xl sm:text-4xl text-white">Connexion</h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-desti-gold mb-2 block">Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              className="w-full bg-desti-black border-b border-white/20 px-3 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-desti-gold transition-colors"
              placeholder="votre@email.fr" data-testid="login-email-input" />
          </div>
          <div className="relative">
            <label className="text-xs uppercase tracking-widest text-desti-gold mb-2 block">Mot de passe</label>
            <input type={showPw ? 'text' : 'password'} required value={password} onChange={e => setPassword(e.target.value)}
              className="w-full bg-desti-black border-b border-white/20 px-3 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-desti-gold transition-colors pr-10"
              placeholder="Votre mot de passe" data-testid="login-password-input" />
            <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-2 bottom-3 text-white/40 hover:text-white/60">
              {showPw ? <EyeSlash size={18} /> : <Eye size={18} />}
            </button>
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading}
            className="w-full bg-desti-gold text-desti-black font-medium py-4 tracking-wide hover:bg-desti-gold-hover transition-colors disabled:opacity-50"
            data-testid="login-submit-btn">
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
        <p className="text-center text-sm text-desti-text mt-8">
          Pas encore de compte ? <Link to="/inscription" className="text-desti-gold hover:text-desti-gold-hover transition-colors" data-testid="register-link">Creer un compte</Link>
        </p>
      </div>
    </div>
  );
}
